import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    '& label > span': {
      fontSize: '14px',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  subtitle: {
    fontWeight: 500,
    color: '#000',
    padding: '20px 0 12px 0',
  },
  chip: {
    color: theme.palette.primary.contrastText,
  },
  active: {
    backgroundColor: theme.palette.success.light,
  },
  expired: {
    backgroundColor: '#F88078',
  },
  pending: {
    backgroundColor: '#757575',
  },
  icon: {
    color: theme.palette.text.secondary,
  },
}))
